import { render } from "./perceraian.vue?vue&type=template&id=dd05c7e2&scoped=true"
import script from "./perceraian.vue?vue&type=script&lang=js"
export * from "./perceraian.vue?vue&type=script&lang=js"

import "./perceraian.vue?vue&type=style&index=0&id=dd05c7e2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dd05c7e2"

export default script